import { atom } from 'recoil';

export const defaultLanguage = atom({
  key: 'en',
  default: {
    label: 'English',
    icon: '/assets/languagesicons/english.svg',
  },
});

export const userSmartAccount = atom({
  key: 'smartAccount',
  default: ''
})

export const userSmartAccountClient = atom({
  key: 'smartAccountClient',
  default: null
})
export const userAccountUsdtBalance = atom({
  key: 'accountUsdtBalance',
  default: 0,
});

export const userSmartAccountUsdtBalance = atom({
  key: 'smartAccountUsdtBalance',
  default: 0,
});

export const userSmartAccountRainBalance = atom({
  key: 'smartAccountRainBalance',
  default: 0,
});

export const userSmartMeeClient = atom({
  key: 'smartMeeClient',
  default: null
})

export const userSessionStorage = atom({
  key: 'sessionStorage',
  default: null
})

export const userGrantedPermissions = atom({
  key: 'grantedPermissions',
  default: null
})

export const userPublicClient = atom({
  key: 'publicClient',
  default: null
})

export const userTotalRewardPoints = atom({
  key: 'totalPoints',
  default: null
})
export const userProfileData = atom({
  key: 'userProfile',
  default: null
})

export const hasUnsavedCreateMarketChanges = atom({
  key: 'hasUnsavedCreateMarketChanges',
  default: false
})

export const pendingNavigationPath = atom({
  key: 'pendingNavigationPath',
  default: null
})

export const rainPriceInUsdt = atom({
  key: 'rainPriceInUsdt',
  default: null
})